import LogRocket from 'logrocket'

const utils = {
  trackLogrocketUser: (user) => {
    LogRocket.identify(user.uuid, {
      name: user.fullName,
      email: user.email,
      username: user.userName,
      appName: process.env.APP_NAME
    })
  }
}

export default utils
